import { useContext, useEffect, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { AbsoluteContainer, AppSpan, AppText, Button, CustomContainer, FixedContainer, FlexRow, GridContainer, Icon, Input, ScreenTitle, SelfScrollContainer } from "src/style"
import { AppCenterPopupD2, CenterPopupHeaderD2, DecisionBox, SmLogoCreation } from "src/component"
import { FiSearch } from "react-icons/fi"
//import { beneficiaries } from "src/utils/mock-data"
import { banksImgSm } from "src/utils/logo"
import { BsThreeDotsVertical } from "react-icons/bs"
import helpers from "src/utils/helpers"
import { AiOutlineDelete } from "react-icons/ai"

export const BeneficiariesD2: React.FC<any> = ({formData, handleSelect, next, close}) => {
    const {API} = useContext(ApiContext)
    const {notifier} = useContext(VisibilityContext)
    const [beneficiaries, setBeneficiaries] = useState<any[]>([])
    const [mockBeneficiaries, setMockBeneficiaries] = useState<any[]>([])
    const [benIdToDelete, setBenIdToDelete] = useState<number|null>(null)
    const [isDecisionBox, setIsDecisionBox] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        handleFetchBeneficiaries()
    }, [])

    async function handleFetchBeneficiaries () {
        setIsLoading(true)
        const response = await API.getBeneficiaries()
        setIsLoading(false)
        if (response) {
            setBeneficiaries(response)
            setMockBeneficiaries(response)
        }
    }

    function handleSearch (e: React.ChangeEvent<HTMLInputElement>) {
        setMockBeneficiaries(helpers.searchTableData(beneficiaries, e.target.value, ['accountName', 'accountNumber', 'bankName']))
    }

    async function handleBeneficiary (item: any) {
        const info = {
            ...formData,
            beneficiaryBank: item.bank?.bankName || item.bankName || "Bank", 
            beneficiaryName: item.accountName, 
            beneficiaryAccount: item.accountNumber,
            beneficiaryBankCode: item.bankCode,
            canSaveBeneficiary: false,
            shouldSaveBeneficiary: false
        }

        if (formData) {
            setIsLoading(true)
            const response = formData?.transferType == '2' ?
                await API.nameInquiryOtherBank({
                    senderAccountNumber: formData.senderAccount,
                    beneficiaryAccountNumber: item.accountNumber,
                    beneficiaryBankCode: item.bankCode
                })
                :
                await API.nameInquirySameBank(item.accountNumber, formData.senderAccount)
            setIsLoading(false)
    
            if (response?.nipSession) {
                info.nipSession = response.nipSession
            }
            else info.beneficiaryAccount = item.accountNumber || ''
        }

        handleSelect({...info})
        next()
    }

    async function handleDeleteBeneficiary (e: React.MouseEvent<HTMLSpanElement>, id: number) {
        e.stopPropagation()
        
        setBenIdToDelete(id)
        setIsDecisionBox(true)
    }

    async function deleteBeneficiary() {
        setIsLoading(true)
        const response = await API.deleteBeneficiary(benIdToDelete)
        setIsLoading(false)
        if (response) {
            await handleFetchBeneficiaries()
            notifier.show('Beneficiary deleted Successfully', null, 'success')
        }
    }

    return (
        <>
            <AppCenterPopupD2 height='87' zIndex='6' close={close} overflow='hidden'>
                <CenterPopupHeaderD2 title='Select Beneficiary' close={close} />
                { (isLoading) &&
                    <AbsoluteContainer 
                        top='0' left='0' zIndex='3' width='100' 
                        sizeUnit='%' height="full" radius="1"
                        style={{overflow: 'hidden'}}
                    >
                        <GridContainer height='100' hUnit="%" bgColor='rgba(255, 255, 255, 0.5)'>
                            <AppSpan textSize='4' color='#0D968F' className='fa fa-spinner fa-spin' />
                        </GridContainer>
                    </AbsoluteContainer> 
                }
                <CustomContainer 
                    height="87"
                    style={{maxHeight: '105%'}}
                    className="popup-content-container"
                >
                    <CustomContainer
                        radius='0.8' borderColor='#D0D5DD' 
                        leftPadding='1.5' rightPadding='1.5' topMargin='2.5'
                        shadow='0px 1px 2px rgba(16, 24, 40, 0.05)'
                        bottomMargin='2'
                    >
                        <FlexRow>
                            <FiSearch style={{fontSize: '2rem', color: '#667085'}} />
                            <Input 
                                height='4.4' leftPadding='1' 
                                placeholder='Search' 
                                onChange={handleSearch}
                            />
                        </FlexRow>
                    </CustomContainer>
                    
                    <SelfScrollContainer
                        height='75' hUnit='%' ssHeight="70" ssHUnit="%"
                        className='overflow-y-container'
                    >
                        {
                            mockBeneficiaries?.map((item: any, index: number) => {
                                const img = (item.bank?.logoURL || item.logoURL) ? 
                                    <GridContainer width="4" height="4" radius="0.4" style={{overflow: 'hidden'}}>
                                        <Icon src={item.bank?.logoURL || item.logoURL} noResize minWidth='100' style={{objectFit: 'contain'}} />
                                    </GridContainer> 
                                    : <SmLogoCreation name={item.bank?.bankName || item.bankName} />
                                return (
                                    (((formData?.transferType == '1' && item.isSameBank) || (formData?.transferType == '2' && !item.isSameBank) || (!formData)) && !item.isDeleted) &&
                                    <GridContainer 
                                        minHeight="7.2" key={index}
                                        className="beneficiary-container"
                                        onClick={() => formData ? handleBeneficiary(item) : null}
                                    >
                                        <FlexRow justifyContent="space-between" gap="1.5" rightPadding="1.5">
                                            <FlexRow width="auto" sizeUnit='' gap="2" alignItems="flex-start">
                                                {img}
                                                <CustomContainer width="auto" sizeUnit="">
                                                    <AppSpan fontWeight="600" color="#101828" cursor="pointer">{item.accountName}</AppSpan>
                                                    <AppText textSize="1.1" color="#667085" cursor="pointer">{item.bank?.bankName || item.bankName} - {item.accountNumber}</AppText>
                                                </CustomContainer>
                                            </FlexRow>
                                            <AppSpan 
                                                textSize="1.8" color='#98A2B3' hoverColor="#F80000"
                                                onClick={(e) => handleDeleteBeneficiary(e, item.id)}
                                            >
                                                <AiOutlineDelete />
                                            </AppSpan>
                                        </FlexRow>
                                    </GridContainer>
                                )
                            })
                        }
                        { !formData &&
                            <FlexRow justifyContent='flex-end' topMargin='2.5'>
                                <Button 
                                    width='17.3' height='4' 
                                    borderColor='#0D968F' hoverBgColor='#fff' 
                                    hoverColor='#0D968F' titleSize='1.4'
                                    onClick={next}
                                >
                                    Add New Beneficiary
                                </Button>
                            </FlexRow>
                        }
                    </SelfScrollContainer>
                </CustomContainer>
            </AppCenterPopupD2>
            { isDecisionBox &&
                <DecisionBox 
                    yesBtnText='Yes, Delete'
                    noBtnTxt='No'
                    message='Are you sure you want to delete beneficiary?'
                    yesMethod={deleteBeneficiary}
                    close={() => setIsDecisionBox(false)} 
                />
            }
        </>
    )
}
